var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65BA70"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#488E53"
    },
    d: "M316.632,115.626c-6.424-1.788-13.013-1.904-19.498-0.601l-32.715-32.715h-16.746v23.185 c-0.042-0.781-0.075-1.226-0.075-1.226s-41.161-3.071-55.202,10.971c-0.63,0.63-1.226,1.344-1.806,2.094 c-25.552,10.775-37.85,46.857-27.577,83.758c5.963,21.42,21.988,44.07,38.888,59.199l-0.14,0.14l18.194,18.194h-74.97 c-25.917,0-46.927,21.01-46.927,46.927c0,12.959,5.252,24.689,13.743,33.182l153.095,153.095 c122.477-4.186,223.108-94.392,243.368-212.104L335.366,126.826l-0.013,0.013C330.115,121.527,323.824,117.628,316.632,115.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C6BB3"
    },
    d: "M413.941,278.625H144.986l0,0c-25.917,0-46.928,21.01-46.928,46.928 c0,25.917,21.01,46.928,46.928,46.928l0,0h268.956v-18.982c-5.805-7.806-9.253-17.468-9.253-27.944 c0-10.477,3.448-20.138,9.253-27.944V278.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.23,353.146h259.595l0.251-55.538H145.23c-15.336,0-27.769,12.433-27.769,27.769l0,0 C117.461,340.713,129.893,353.146,145.23,353.146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EA971E"
    },
    points: "212.483,372.48 193.352,366.447 174.221,372.48 174.221,309.723 212.483,309.723 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A4997"
    },
    d: "M413.941,278.625H256.245v93.854h157.696v-18.982c-5.805-7.806-9.253-17.468-9.253-27.944 c0-10.477,3.448-20.138,9.253-27.944V278.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9ED9D"
    },
    d: "M413.941,297.609H256.245v55.538H413.69c-5.651-7.745-9.003-17.271-9.003-27.593 C404.688,315.076,408.136,305.415,413.941,297.609z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C27526"
    },
    points: "193.352,309.723 193.352,366.447 212.483,372.48 212.483,309.723 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.67,
    y: 82.314,
    style: {
      fill: "#67573E"
    },
    width: 16.748,
    height: 79.301
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25F3F"
    },
    d: "M316.632,115.626c-10.867-3.026-22.214-1.318-32.719,4.082c-17.494,8.992-38.255,8.977-55.752-0.01 c-10.499-5.393-21.839-7.096-32.7-4.072c-28.827,8.025-43.354,46.29-32.448,85.468c10.907,39.178,55.472,82.466,77.489,76.337 c5.723-1.593,11.022-6.837,15.544-14.405c4.521,7.569,9.822,12.812,15.543,14.405c22.018,6.129,66.584-37.159,77.489-76.337 C359.985,161.915,345.458,123.65,316.632,115.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8DC652"
    },
    d: "M236.628,159.471c-14.042,14.042-59.381,15.15-59.381,15.15s1.109-45.341,15.15-59.381 c14.042-14.042,55.202-10.971,55.202-10.971S250.668,145.43,236.628,159.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6AAF50"
    },
    d: "M236.628,159.471c-14.042,14.042-59.381,15.15-59.381,15.15l70.353-70.353 C247.598,104.27,250.668,145.43,236.628,159.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BB161B"
    },
    d: "M316.632,115.626c-10.867-3.026-22.214-1.318-32.719,4.082c-8.744,4.495-18.305,6.739-27.867,6.738 v136.58c4.521,7.569,9.822,12.812,15.544,14.405c22.018,6.129,66.584-37.159,77.489-76.337 C359.985,161.915,345.458,123.65,316.632,115.626z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.05149eddf09c03bf515c96de087fdf05.svg";
export { ForwardRef as ReactComponent };